import { Injectable } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { AdMob, RewardedAd, InterstitialAd } from '@admob-plus/ionic/ngx';
import { Events } from 'plugins/admob-plus-cordova/esm';
import { environment } from 'src/environments/environment';
import { WebUtils } from '@app/util/WebUtils';
import { StorageService } from '@services/storage/storage.service';
import { OfflineTutorialsPage } from '@app/offline-tutorials/offline-tutorials.page';
import { UserStoreService } from '@services/api/user-store/user-store.service';
import { AnalyticsService } from '@services/analytics/analytics.service';
import { AnalyticsEventEnum } from '@models/AnalyticsEventEnum';
import moment from 'moment';

const ADS_COUNT = 'ADS_COUNT';

@Injectable({
  providedIn: 'root'
})
export class AdsService {
  private rewardedAd: RewardedAd;
  private interstitialAd: InterstitialAd;
  private isStart: boolean = false;
  public isIOS: boolean = false;

  private adUnitId: string = '';
  private interstitialAdId: string = '';

  constructor(
    private admob: AdMob,
    private userStoreService: UserStoreService,
    private modalCtrl: ModalController,
    private storageService: StorageService,
    private platform: Platform,
    private analyticsService: AnalyticsService
  ) {}

  async init() {
    try {
      await this.platform.ready();

      if (WebUtils.isWeb()) {
        return;
      }

      this.isIOS = this.platform.is('ios');

      if (this.userOlderThan30Days()) {
        this.adUnitId = this.isIOS ? environment.adUnitIdIOS2 : environment.adUnitId2;
      } else {
        this.adUnitId = this.isIOS ? environment.adUnitIdIOS : environment.adUnitId;
      }

      this.interstitialAdId = this.isIOS ? environment.interstitialAdIOS : environment.interstitialAd;

      await this.admob.start().catch((e) => { console.error(e)});
    } catch (e) {
      console.error(e);
    }
  }

  async requestTrackingAuthorization() {
    try {
      if (this.isIOS) {
        this.admob.requestTrackingAuthorization();
      }
    } catch (e) {
      console.error(e);
    }
  }

  async resolvePrefetch() {
    try {
      if (!this.isStart) {
        this.initSubscribe();
        this.rewardedAd = new this.admob.RewardedAd({
          adUnitId: this.adUnitId
        });

        this.interstitialAd = new this.admob.InterstitialAd({
          adUnitId: this.interstitialAdId
        });

        this.isStart = true;
        this.loadRewardedAd();
        this.loadInterstitialAd();
      }
    } catch (e) {
      console.error(e);
    }
  }

  private initSubscribe() {
    this.admob.on(Events.rewardedReward).subscribe((_) => {
      this.loadRewardedAd();
      this.resolveADCount();
    });

    this.admob.on(Events.interstitialShow).subscribe((_) => {
      this.loadInterstitialAd();
      this.resolveADCount();
    });
  }

  getRewarded() {
    return this.rewardedAd;
  }

  async loadRewardedAd() {
    const isLoaded = await this.rewardedAd.isLoaded();

    if (!isLoaded) {
      await this.rewardedAd.load();
    }

    return this.rewardedAd;
  }

  async resolveADCount() {
    try {
      await this.increaseADCount();
      await this.shouldDisplayOTOBasedOnAdCount();
    } catch (e) {}
  }

  async loadInterstitialAd() {
    const isLoaded = await this.interstitialAd.isLoaded();

    if (!isLoaded) {
      await this.interstitialAd.load();
    }

    return this.interstitialAd;
  }

  async increaseADCount() {
    try {
      const currentCount = (await this.storageService.get(ADS_COUNT)) || 0;
      const newCount = currentCount + 1;
      this.storageService.set(ADS_COUNT, newCount);
    } catch (e) {}
  }

  async openHelper(componentProps: any) {
    const modal = await this.modalCtrl.create({
      component: OfflineTutorialsPage,
      componentProps,
      cssClass: 'sd modal-transparent'
    });

    await modal.present();

    return modal;
  }

  async shouldDisplayOTOBasedOnAdCount() {
    try {
      const currentCount = await this.storageService.get(ADS_COUNT);

      if (currentCount === 2) {
        //this._2ad();
      }

      if (currentCount % 10 === 0) {
        //this._10AD();
      }
    } catch (e) {}
  }

  private userOlderThan30Days() {
    try {
      const userCreateDate = moment(this.userStoreService.user.createdAt).toDate();
      const now = new Date();

      const diffInDays = Math.floor((now.getTime() - userCreateDate.getTime()) / (1000 * 60 * 60 * 24));

      return diffInDays >= 30;
    } catch (e) {}
    return false;
  }

  private mountOTOofferLink(plano: 'anual_com_desconto' | 'anual' ,medium: string): string {
    const userEmail = this.userStoreService.user.email;
    const userObjectId = this.userStoreService.user.objectId;

    const urlBase = 'https://app.estudaqui.com/assinar';

    const url = new URL(urlBase);
    url.searchParams.append('email', userEmail);
    url.searchParams.append('userId', userObjectId);
    url.searchParams.append('plano', 'anual_com_desconto');
    url.searchParams.append('utm_source', 'app_estudaqui');
    url.searchParams.append('utm_medium', medium); // ajuste conforme o local da promoção
    url.searchParams.append('utm_campaign', environment.appVersionCode.toString());
    url.searchParams.append('utm_content', 'versao_a');

    return url.toString();
  }

  async _2ad() {
    try {
      const firstname = this.userStoreService.user.fullname.split(' ')[0];
      const urlString = this.mountOTOofferLink('anual', 'popup_2ad_offer');

      const prop = {
        title: 'Cansou de Interrupções? ',
        offerURL: urlString,
        offerIcon: 'assets/icon/block.png',
        youtubeTextHTML: 'Acabe com as interrupções',
        isIOS: this.isIOS,
        withDiscount: false,
        message: `
            Oi <${firstname}>, cansou de propaganda aparecendo bem na hora que você está focando nos estudos ?
            Que tal <aproveitar> nosso <plano anual> e se livrar deles de vez? 
            Com o plano premium anual, você curte o <Estudaqui sem limites>
            Sem anúncios e com todas as funcionalidades liberadas.<Total liberdade> para estudar do seu jeito. 
            É a chance perfeita para transformar seu aprendizado sem distrações!
            Bora aproveitar? 
        `,
        isDismissable: false,
        sendOpenBtnEvent: 'POPUP_offer_2AD_cta_clicked'
      };
      this.openHelper(prop);


      this.analyticsService.logEvent(AnalyticsEventEnum.POPUP_OFFER_2AD);
    } catch (e) {}
  }

  async _10AD() {
    try {
      const firstname = this.userStoreService.user.fullname.split(' ')[0] || '';
      const urlString = this.mountOTOofferLink('anual_com_desconto', 'popup_one_time_offer');

      const prop = {
        title: 'Cansou de interrupções? ',
        offerURL: urlString,
        youtubeTextHTML: 'Aproveitar Oferta <br> 20% OFF',
        isIOS: this.isIOS,
        withDiscount: false,
        message: `
            Oi <${firstname}>, cansou de anúncios aparecendo bem na hora que você está focando nos estudos ?
            Que tal <aproveitar> nossa <oferta do plano anual> com <20% de desconto> e se livrar deles de vez? 
            E não só isso, com o plano premium, você estuda <com todas as funcionalidades liberadas>
            É a chance perfeita para turbina seu estudos sem distrações!
            Bora aproveitar? 
        `,
        isDismissable: false,
        sendOpenBtnEvent: 'POPUP_offer_10AD_cta_clicked'
      };
      this.analyticsService.logEvent(AnalyticsEventEnum.POPUP_OFFER_10AD);

      this.openHelper(prop);
    } catch (e) {}
  }
}
